/** Share link for the Loan Calculator: only the typed numbers and choices go in the address (replaceState), nothing is stored. */
export interface LoanShare { principal: string; rate: string; term: string; unit: "years" | "months"; extra: string; currency: string; method: "reducing" | "flat" }
export const LOAN_DEFAULTS: LoanShare = { principal: "100000", rate: "5", term: "30", unit: "years", extra: "0", currency: "USD", method: "reducing" };
const KEYS: Record<keyof LoanShare, string> = { principal: "amt", rate: "rate", term: "term", unit: "unit", extra: "xm", currency: "cur", method: "m" };
const NUMERIC = /^[\d.,\s$%-]{0,14}$/;

export function loanToQuery(s: LoanShare): string {
  const p = new URLSearchParams();
  (Object.keys(KEYS) as (keyof LoanShare)[]).forEach((k) => { if (s[k] !== LOAN_DEFAULTS[k]) p.set(KEYS[k], s[k]); });
  return p.toString();
}
export function loanFromQuery(search: string, currencies: string[] = []): LoanShare {
  const p = new URLSearchParams(search), out: LoanShare = { ...LOAN_DEFAULTS };
  for (const k of ["principal", "rate", "term", "extra"] as const) { const v = p.get(KEYS[k]); if (v !== null && NUMERIC.test(v)) out[k] = v; }
  const unit = p.get(KEYS.unit); if (unit === "years" || unit === "months") out.unit = unit;
  const method = p.get(KEYS.method); if (method === "reducing" || method === "flat") out.method = method;
  const cur = p.get(KEYS.currency); if (cur && /^[A-Z]{3}$/.test(cur) && (currencies.length === 0 || currencies.includes(cur))) out.currency = cur;
  return out;
}
